module.exports = __webpack_public_path__ + "img/icon-about-4.cc414d8f.png";